import { createContext, useContext } from "react";

export interface DocumentCraftingWorkspaceValue {
  /** The workspace a platform admin switched to; null = their own. Always
   * null for everyone else. */
  workspaceId: number | null;
  /** Admins only: work in another workspace (null = back to their own).
   * Clears the module's cached data and remounts the page. */
  switchWorkspace: (workspaceId: number | null) => void;
}

export const DocumentCraftingWorkspaceContext =
  createContext<DocumentCraftingWorkspaceValue>({
    workspaceId: null,
    switchWorkspace: () => undefined,
  });

/** The admin workspace switch of the module (provided by the layout). */
export const useDocumentCraftingWorkspace = () =>
  useContext(DocumentCraftingWorkspaceContext);
